export default __webpack_public_path__ + "static/media/caps.0d2e60d0.JPG";